import {
  getAllCompaniesStart,
  getAllCompaniesSuccess,
  getAllCompaniesFailure,
  addCompanyStart,
  addCompanySuccess,
  addCompanyFailure,
  fetchCompanyDetailsStart,
  fetchCompanyDetailsSuccess,
  editCompanyStart,
  editCompanySuccess,
  editCompanyFailure,
  setSelectedCompanyID,
  resetCompanyDetails,
  resetSnackbar,
  setFilteredCompanyList,
} from './company.slice';
import {
  fetchAllCompaniesApi,
  addNewCompanyApi,
  fetchCompanyDetailsApi,
  editCompanyApi,
} from '../api/company.api';

export const fetchAllCompanies = () => async (dispatch) => {
  dispatch(getAllCompaniesStart());
  try {
    const response = await fetchAllCompaniesApi();
    dispatch(getAllCompaniesSuccess(response.data));
  } catch (error) {
    dispatch(getAllCompaniesFailure(error.response.data));
  }
};

export const addCompany = (companyData) => async (dispatch) => {
  dispatch(addCompanyStart());
  try {
    const response = await addNewCompanyApi(companyData);
    dispatch(addCompanySuccess(response.data));
  } catch (error) {
    dispatch(addCompanyFailure(error.response.data));
  }
};

export const getCompanyDetails = (companyid) => async (dispatch) => {
  dispatch(fetchCompanyDetailsStart());
  const company = await fetchCompanyDetailsApi(companyid);
  dispatch(fetchCompanyDetailsSuccess(company.data));
};

export const editCompany = (companyData) => async (dispatch) => {
  dispatch(editCompanyStart());
  try {
    const response = await editCompanyApi(companyData);
    dispatch(editCompanySuccess(response.data));
  } catch (error) {
    dispatch(editCompanyFailure(error.response.data));
  }
};

export const setCompanyID = (companyid) => async (dispatch) => {
  dispatch(setSelectedCompanyID(companyid));
};

export const resetCompany = () => async (dispatch) => {
  dispatch(resetCompanyDetails());
};

export const resetSnackbarDetails = () => async (dispatch) => {
  dispatch(resetSnackbar());
};

export const setFilteredCompanies = (companies) => async (dispatch) => {
  dispatch(setFilteredCompanyList(companies));
};
